import { Field } from '#app/components/form/field.tsx'
import { Section } from '#app/routes/mocra+/_form+/components/section.tsx'
import { type SectionResources } from '#app/routes/mocra+/_form+/section-resources.ts'

type Props = {
	readonly resources: SectionResources
	readonly skuCount: string
	readonly errors: readonly string[]
	readonly onChange: (value: string) => void
}

export function PortfolioOverviewSection({
	resources,
	skuCount,
	errors,
	onChange,
}: Props) {
	return (
		<Section
			title="Portfolio overview"
			description="Record the total SKU count so generated summaries stay aligned with your catalog."
			mocraSections={resources.mocraSections}
			templates={resources.templates}
			childrenClassName="space-y-6"
		>
			<Field
				labelProps={{
					children: 'How many cosmetic SKUs do you currently sell in the U.S.?',
				}}
				inputProps={{
					name: 'activeSkuCount',
					type: 'number',
					value: skuCount,
					onChange: (event) => onChange(event.target.value),
				}}
				descriptionProps={{
					children:
						'Include direct-to-consumer and wholesale items that remain on the market.',
				}}
				errors={errors.length > 0 ? [...errors] : undefined}
			/>
		</Section>
	)
}
